const elements = document.querySelectorAll('ul[style="list-style-type: circle;"] > li');
for (var i = 0; i < elements.length; i++) {
  const el = elements[i];
  el.addEventListener('click', function(e) {
    el.classList.toggle('-bullet-list-open');
  }.bind(el));
}
